import { useLoadImage } from 'src/app/shared/hooks/image';

import type { NewlyCreatedPetition } from '../../../../../../types';

type Options = {
	petition: { node: NewlyCreatedPetition };
};

type Result = ModelHookResult<{
	petitionUrl: string;
	photoUrl?: string;
}>;

const MAX_ATTEMPTS = 10;
const POLLING_TIME = 3 * 1000; // 3sec

export function useNewlyCreatedPetitionCard({ petition }: Options): Result {
	const {
		node: { photo },
	} = petition;

	const finalPhoto = photo?.petitionSmall;
	const imageLoaded = useLoadImage(finalPhoto?.url, {
		maxAttempts: MAX_ATTEMPTS,
		pollingTime: POLLING_TIME,
		processing: finalPhoto?.processing,
	});

	return {
		data: {
			photoUrl: imageLoaded || finalPhoto ? finalPhoto?.url : '',
			petitionUrl: `/p/${petition.node.slug}`,
		},
	};
}
